var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ee339a","d":"M436.9 74.9a256.3 256.3 0 00-362 0 256.3 256.3 0 000 362c49.9 50 115.4 74.9 181 74.9s131-25 181-74.9a256.3 256.3 0 000-362zm-75.4 256.4a21.3 21.3 0 11-30.2 30.2L255.9 286l-75.4 75.5a21.3 21.3 0 01-30.2-30.2l75.4-75.4-75.4-75.4a21.3 21.3 0 1130.2-30.2l75.4 75.4 75.4-75.4a21.3 21.3 0 1130.2 30.2L286 255.9l75.5 75.4z"}));
}

CloseIcon.defaultProps = {"viewBox":"0 0 511.8 511.8"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
